<template>
<div class="safe-bottom"></div>
</template>

<script>
import Utils from "../utils/Utils";
export default {
  name: "SafeBottom",
  data(){
    return {
      app:"",
    };
  },
  mounted: function() {
    this.app = Utils.getApp();
  }
}
</script>

<style>
.safe-bottom {
  height: 34px;
}
@media screen and (device-width: 375px) and (device-height: 812px){
  .safe-bottom {
    height: 34px;
  }
}
@media screen and (device-width: 414px) and (device-height: 896px){
  .safe-bottom {
    height: 34px;
  }
}
@media screen and (device-width: 428px) and (device-height: 926px){
  .safe-bottom {
    height: 34px;
  }
}
@media screen and (device-width: 390px) and (device-height: 844px){
  .safe-bottom {
    height: 34px;
  }
}
@media screen and (device-width: 360px) and (device-height: 780px){
  .safe-bottom {
    height: 34px;
  }
}
/*@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {*/
/*  .safe-bottom {*/
/*    height: constant(safe-area-inset-bottom);*/
/*    height: env(safe-area-inset-bottom);*/
/*  }*/
/*}*/
</style>